/* istanbul ignore file */
import React from 'react';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import { BEGIN_STYLE_QUIZ_LINK } from '@constants/styleQuiz';
import styles from './Footer.module.scss';

export default function AllReviews() {
  const theme = useTheme();
  return (
    <div className={classNames(
      theme.styles.Section,
      theme.styles.Core6,
      styles.Footer
    )}
    >
      <h3 className={theme.styles.Title1}>Love this piece? Update your space with expert help.</h3>
      <a
        href={BEGIN_STYLE_QUIZ_LINK}
        className={theme.styles.Button}
      >
        Take our style quiz
      </a>
    </div>
  );
}
